import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M10.5901 82.0499H63.4301L73.7801 26.5699L65.2001 1.90991H9.93005L1.56006 26.35L10.5901 82.0499Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
